import React, { useMemo, useState } from 'react';
import { INITIAL_MARKDOWN, VIVARA_INITIAL_MARKDOWN } from './common';
import { useIsVivara } from '../../hooks/useIsVivara';

interface IDailyPlannerContext {
  todoEditorOpen: boolean;
  setTodoEditorOpen(open: boolean): void;
  markdown: string;
  setMarkdown(text: string): void;
  // addTodoItem(text: string): void;
  // completeTodoItem(text: string): void;
}

export const DailyPlannerContext = React.createContext<IDailyPlannerContext>({
  markdown: '',
  todoEditorOpen: false,
  setMarkdown: () => {},
  // completeTodoItem: () => {},
  setTodoEditorOpen: () => {},
});

export const DailyPlannerContextProvider: React.FC<{ children: React.ReactChild }> = ({ children }) => {
  const isVivara = useIsVivara();
  const [markdown, setMarkdown] = useState(isVivara ? VIVARA_INITIAL_MARKDOWN : INITIAL_MARKDOWN);
  const [todoEditorOpen, setTodoEditorOpen] = useState(false);

  const context = useMemo<IDailyPlannerContext>(() => ({
    markdown,
    setMarkdown,
    todoEditorOpen,
    setTodoEditorOpen,
  }), [markdown, setMarkdown, todoEditorOpen, setTodoEditorOpen]);

  return (
    <DailyPlannerContext.Provider value={context}>
      {children}
    </DailyPlannerContext.Provider>
  );
};
